module.exports = __webpack_public_path__ + "static/media/minus-icon.87357fd9.svg";